import React, { useEffect } from "react";
import styles from "./rosterManagement.module.css";
import stylesTime from "./Components/checkBox.module.css";
import { weekDays } from "./rosterFun";
import { TimeSlot } from "./Components/TimeSlot";
import { useSelector } from "react-redux";
import moment from "../../../../../node_modules/moment/moment";
export const StaffDataSec = ({ tHead, timeSlotsBooked, staffTimeSlotdata }) => {
  const timeSlotdata = [
  { id: "00:00:00", value: "00:00:00" },
  { id: "00:30:00", value: "00:30:00" },
  { id: "01:00:00", value: "01:00:00" },
  { id: "01:30:00", value: "01:30:00" },
  { id: "02:00:00", value: "02:00:00" },
  { id: "02:30:00", value: "02:30:00" },
  { id: "03:00:00", value: "03:00:00" },
  { id: "03:30:00", value: "03:30:00" },
  { id: "04:00:00", value: "04:00:00" },
  { id: "04:30:00", value: "04:30:00" },
  { id: "05:00:00", value: "05:00:00" },
  { id: "05:30:00", value: "05:30:00" },
  { id: "06:00:00", value: "06:00:00" },
  { id: "06:30:00", value: "06:30:00" },
  { id: "07:00:00", value: "07:00:00" },
  { id: "07:30:00", value: "07:30:00" },
  { id: "08:00:00", value: "08:00:00" },
  { id: "08:30:00", value: "08:30:00" },
  { id: "09:00:00", value: "09:00:00" },
  { id: "09:30:00", value: "09:30:00" },
  { id: "10:00:00", value: "10:00:00" },
  { id: "10:30:00", value: "10:30:00" },
  { id: "11:00:00", value: "11:00:00" },
  { id: "11:30:00", value: "11:30:00" },
  { id: "12:00:00", value: "12:00:00" },
  { id: "12:30:00", value: "12:30:00" },
  { id: "13:00:00", value: "13:00:00" },
  { id: "13:30:00", value: "13:30:00" },
  { id: "14:00:00", value: "14:00:00" },
  { id: "14:30:00", value: "14:30:00" },
  { id: "15:00:00", value: "15:00:00" },
  { id: "15:30:00", value: "15:30:00" },
  { id: "16:00:00", value: "16:00:00" },
  { id: "16:30:00", value: "16:30:00" },
  { id: "17:00:00", value: "17:00:00" },
  { id: "17:30:00", value: "17:30:00" },
  { id: "18:00:00", value: "18:00:00" },
  { id: "18:30:00", value: "18:30:00" },
  { id: "19:00:00", value: "19:00:00" },
  { id: "19:30:00", value: "19:30:00" },
  { id: "20:00:00", value: "20:00:00" },
  { id: "20:30:00", value: "20:30:00" },
  { id: "21:00:00", value: "21:00:00" },
  { id: "21:30:00", value: "21:30:00" },
  { id: "22:00:00", value: "22:00:00" },
  { id: "22:30:00", value: "22:30:00" },
  { id: "23:00:00", value: "23:00:00" },
  { id: "23:30:00", value: "23:30:00" }
];

  //set Booked date in Header Color green

  const timeSlotsBookeddate = [...new Set(timeSlotsBooked?.map((i) => i.date))];

  const weekArr = tHead?.filter((k) =>
    timeSlotsBookeddate.includes(k?.date?.toString().padStart(2, 0))
  );


  const bookedDataObj = {};
  for (const k of weekArr) {
    bookedDataObj[k?.date] = true;
  }


  const {selectWeek } = useSelector((i) => i.WeekFilterSlice);

  useEffect(() => {
    for(let i=0; i<tHead?.length; i++ ){
      document.getElementById('styleId'+i)?.scrollTo(0, 0)
    }
    
  },[selectWeek])

  const isLeave = staffTimeSlotdata?.leave
  ?.filter((i) => i?.is_leave)
  const is_leave_Date = isLeave?.map((k) => moment(k?.schedule_date).format("DD"))
  const isLeaveBooked = tHead?.map((j) => j?.disabled ? false : is_leave_Date?.includes(j?.date?.toString().padStart(2, 0)))
  return (
    <div className={styles.tablemain}>
      <table className={styles.table}>
        <tr className={styles.tableTr}>
          {tHead.map((item, i) => {
            return (
              <th
                className={`${styles.thead} ${
                  item.disabled === true ? styles.timeDisable : ""
                }`}
              >
                <div className={styles.thDiv}>
                  <div className={styles.monthDay}>{weekDays[i]}</div>
                  <div
                    className={`${styles.monthDate} ${
                      item.disabled === true 
                      ? '' 
                      : bookedDataObj[item?.date] 
                      ? styles.bookedDate 
                      : ''
                    }
                    ${isLeaveBooked[i] ? styles.isLeave : ''}
                    `}
                  >
                    {item?.date}
                  </div>
                </div>
              </th>
            );
          })}
        </tr>
        <tr className={styles.tableTr}>
          {tHead.map(({ date, disabled }, i) => {
            const bookedSlot = disabled
              ? []
              : timeSlotsBooked?.filter(
                  (i) => i.date === date.toString().padStart(2, 0)
                );

            return (
              <td
                className={`${styles.tdData} ${
                  disabled ? styles.timeDisable : ""
                }`}
              >
                <div className={styles.scrollbar} id={"styleId"+i}>
                  <div className={styles.timeSlot}>
                    {timeSlotdata?.map((item) => {
                      const bookedTime = bookedSlot
                        ?.map((j) => j.timeId)
                        .includes(item.id);

                      return (
                        <div className={stylesTime.timeSlotContainerView}>
                          <div
                            className={`${stylesTime.timeSlotCheckBoxView} ${
                              stylesTime.selectCheckedCheckBoxView
                            } ${bookedTime ? stylesTime.bookedTimeSlot : ""}`}
                          >
                            <label>
                              <span>{item.value}</span>
                            </label>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </td>
            );
          })}
        </tr>
      </table>
    </div>
  );
};
